/**
 * Shared tooltip className applied to all SidebarMenuButton tooltips in this sidebar.
 * Set it here to keep tooltip styling consistent across all sidebar buttons.
 */
export const SIDEBAR_TOOLTIP_CLASS =
  "bg-popover text-popover-foreground [&>span>svg]:fill-popover";
